module.exports = __webpack_public_path__ + "img/leverage-1.b2769928.png";